import React from 'react';
import { Controller, useFormContext, useFieldArray } from 'react-hook-form';
import { LabeledInput } from 'components/form-elements/inputs/LabeledInput';
import { Text } from 'components/typography';
import { Message, Button, Icon } from 'semantic-ui-react';
import { DiscardIcon } from 'assets/icons/DiscardIcon';
import styles from './styles.module.scss';

export const IntercomNumbers = () => {
  const formContext = useFormContext();
  const control = formContext && formContext.control;
  const errors = (formContext && formContext.formState && formContext.formState.errors) ? formContext.formState.errors : {};

  const { fields, append, remove } = useFieldArray({ control, name: 'phoneNumbers' });

  return (
    <>
      {fields.map((field, index) => {
        const itemError = errors && errors.phoneNumbers && errors.phoneNumbers[index];
        return (
          <div key={field.id}>
            <div
              className={styles.intercomContainer}
            >
              <Controller
                name={`phoneNumbers.${index}.Number`}
                control={control}
                render={({ field: { ref, onChange, value } }) => (
                  <LabeledInput
                    labelIntl={index === 0 ? 'intercomNumber' : ''}
                    id={`phoneNumbers.${index}.Number`}
                    value={value}
                    inputRef={ref}
                    onChange={onChange}
                    hasError={!!(itemError && itemError.Number)}
                  />
                )}
              />

              {fields.length > 1 && (
              <Button
                basic
                size="small"
                type="button"
                icon
                onClick={() => remove(index)}
                aria-label={`remove-phone-${index}`}
              >
                <DiscardIcon size={18} />
              </Button>
              )}
            </div>
            {itemError && itemError.Number && (

              <Message negative>
                <Message.Content>
                  <Text
                    error
                    intl={itemError.Number.message}
                  />
                </Message.Content>
              </Message>

            )}
          </div>
        );
      })}

      <Button
        type="button"
        size="small"
        onClick={() => append({ Number: '' })}
        className={styles.addIntercomButton}
      >
        <Icon name="plus" />
      </Button>
    </>
  );
};
